export default "__VITE_ASSET__c1bXov6b__"